module.exports = __webpack_public_path__ + "img/delete.ed5e1c59.svg";